export default __webpack_public_path__ + "static/page_background_red-d38f63ec194fd6934269cc95fe4180d3.jpg";